import React, {useEffect, useState} from "react";
import "../Dashboard.css";
import "../Sidebar.js";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import DashboardMenu from "../../layout/dashboardMenu";
import Loader from "../../../Loader/Loader";
import Moment from "moment";
import {fireEvent} from "../../MoEngage";
import { moeAddEmail, moeAddFirstName, moeAddUniqueUserId } from "../../../utils/moengage";

const Home = ({
                  homePageContent,
                  homePageDetails = [],
                  fetchReportee,
                  reportee = [],
                  lastTenDaysInactiveAccount,
                  inactiveAccount = [],
                  history,
                  homeFilter,
                  filterDetails=[]
              }) => {

    const [isLoading, setIsLoading] = useState(false)
    const [homeData, setHomeData] = useState([])
    const [pieChartData, setPieChartData] = useState([["Account", "Type"]])
    const [barChartData, setBarChartData] = useState([["Element", "Leads", {role: "style"}]])
    const [lastTenDaysInactiveAccountContent, setLastTenDaysInactiveAccount] = useState([])
    const [userId, setUserId] = useState('')
    const [roleId, setRoleId] = useState('')
    const [open, setOpen] = useState(false);
    const [filterInputList, setFilterInputList] = useState([{}])
    const [filterView, setfilterView] = useState([{}])
    const [isFilterRemove, setIsRemoveFilter] = useState(false)

    useEffect(() => {
        if(window.localStorage?.user_id){
            moeAddFirstName(window.localStorage?.name);
            moeAddEmail(window.localStorage?.userId);
            moeAddUniqueUserId(window.localStorage?.user_id);
        }

    }, [])
    useEffect(() => {
        if (homePageDetails && homePageDetails?.data !== undefined ) {
            setHomeData(homePageDetails?.data)
            /* eslint-disable */
            setLastTenDaysInactiveAccount(homePageDetails?.data?.last_ten_days_Activities)
            homePageDetails?.data?.stage.map((val, i) => {
                pieChartData[pieChartData.length] = [val?.name, val?.total]
                barChartData[barChartData.length] = [val?.name, val?.total, "color:" + val?.color]
            })
            setPieChartData(pieChartData)
            setBarChartData(barChartData)
        }
    }, [homePageDetails])

    useEffect(() => {
        if (inactiveAccount && inactiveAccount?.data !== undefined) {
            setLastTenDaysInactiveAccount(inactiveAccount?.data)
        }
    }, [inactiveAccount])

    useEffect(() => {
        if (homeData && homeData!== undefined) {
            localStorage.setItem("is_pm", JSON.stringify(homeData?.is_pm));
        }
    }, [homeData])


    const handleMessage = (event) => {
        const message = event.data;
        console.log("Call Log Event Response "+JSON.stringify(message))

    };

    useEffect(() => {
        setUserId(window.localStorage.user_id)
        fireEvent('debugging_event', {
            page: window.location?.pathname,
            is_page_loading_start: 'start',
            type: 'page_loading'
        });
        (async () => {
            setIsLoading(true)
            if(!window.localStorage.reload_home) {
                window.localStorage.reload_home  = true;
                window.location.reload();
            }
            setIsLoading(true)
            // TODO: Hit parallel, Promise.all.then(setIsLoading(false))
            Promise.all([
                homePageContent(),
                fetchReportee(),
                homeFilter(window.localStorage?.user_id),
            ]).then((data) => {
                setIsLoading(false)
            }).catch((error) => {
                setIsLoading(false)
            });
            // setIsLoading(false)
            // await homePageContent()
            // await fetchReportee()
            // await homeFilter()
        })();
        setRoleId(window.localStorage.role_id);
        fireEvent('debugging_event', {
            page: "src/component/Dealer/Activity/Complete/Complete.js",
            source:'leadx',
            type: 'page_loading',
            isPageLoadingStart: 'finished',
        })
    }, []);

    const handleLastFewsDaysActivity = async (e, userId) => {
        e.preventDefault()
        if (userId === '') {
            return false
        }

        setIsLoading(true);
        await lastTenDaysInactiveAccount(userId)
        setIsLoading(false);
    }

    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        const view = [...filterView]
        list[0][key] = value
        view[0][key] = value
        if (stringValue !== '') {
            view[0][key] = stringValue
            setfilterView(view)
        } else {
            setfilterView(view)
        }
        setFilterInputList(list)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await homePageContent(filterInputList)
        setIsLoading(false)
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setfilterView([{}])
                setFilterInputList([{}])
                setIsLoading(true)
                await homePageContent()
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterView[0][key]
            delete filterInputList[0][key]
            delete filterInputList[0][key + "_name"]
            setfilterView(filterView)
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await homePageContent(filterInputList)
            setIsLoading(false)
        }
    }

    return (
        <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            history={history}
                        />


                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between mb-2">
                                    <div className="row col-md-12">
                                        {/* <div className="col-md-6 col-sm-6 d-flex mt-20px">
                              <h1 className="h3 mb-0 text-black-100">Home</h1>
                             </div> */}
                                        <div className="col-md-6 cs-pos">
                                            {/* <a href="#"
                                               className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm float-right btn-dwn"><i
                                                className="fas fa-download fa-sm"></i><span
                                                className="report-text">&nbsp;Generate Report</span></a> */}
                                            <div className="">
                                                <button onClick={() => setOpen(!open)}
                                                        className="btn btn-sm btn-primary mr-1 btn-filter"
                                                        type="button"><i
                                                    className="fa fa-filter lh-35 pd-3"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="col-md-6 cs-pos hide">
                                            <a href="src/component/Dashboard/Home/Home#"
                                               className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm float-right"><i
                                                className="fas fa-download fa-sm text-white-50"></i> Generate Report</a>
                                        </div>
                                    </div>
                                </div>

                                {filterView[0] !== undefined && Object.keys(filterView[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mt-20px"
                                         style={{marginTop: "36px"}}>
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterView[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterView[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="row mt-20px">
                                </div>
                                    <div className="col-md-12 col-sm-12" style={{marginTop:"48px"}}>
                                        <div className="card shadow mb-4">
                                            <div className="card-body">
                                                <h4 className="small font-weight-bold text-black-100">Today's Meetings<span
                                                    className="float-right">{homeData?.avg_today_complete_meeting}%</span></h4>
                                                <div className="progress mb-4">
                                                    <div className="progress-bar bg-success" role="progressbar"
                                                         style={{"width" : `${homeData?.avg_today_complete_meeting}%`}}
                                                         aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                                                    </div>
                                                </div>
                                                <hr className="hr-line"/>
                                                <div className="d-flex">
                                                    <div className="sl text-center sl-border">
                                                        <span className="">Total</span>
                                                        <span>{homeData?.total_today_meeting_completed + homeData?.total_today_meeting_pending}</span>
                                                    </div>
                                                    <div className="sl text-center sl-border">
                                                        <span className="cgs">Pending</span>
                                                        <span>{homeData?.total_today_meeting_pending}</span>
                                                    </div>
                                                    <div className="sl text-center">
                                                        <span className="bgs">Completed</span>
                                                        <span>{homeData?.total_today_meeting_completed}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                <div className="col-md-12 col-sm-12" style={{marginTop:"48px"}}>
                                    <div className="card shadow mb-4">
                                        <div className="card-body">
                                            <h4 className="small font-weight-bold text-black-100">Meetings Rating<span
                                                className="float-right">{homeData?.average_rating}%</span></h4>
                                            <div className="progress mb-4">
                                                <div className="progress-bar bg-success" role="progressbar"
                                                     style={{"width" : `${(parseFloat(homeData?.average_rating)/5)*100}%`}}
                                                     aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">
                                                </div>
                                            </div>
                                            <hr className="hr-line"/>
                                            <div className="d-flex">
                                                <div className="sl text-center sl-border">
                                                    <span className="">Total</span>
                                                    <span>{homeData?.total_rating_meeting}</span>
                                                </div>
                                                <div className="sl text-center sl-border">
                                                    <span className="cgs">Rated</span>
                                                    <span>{homeData?.total_rated_meeting}</span>
                                                </div>
                                                <div className="sl text-center">
                                                    <span className="bgs">Average</span>
                                                    <span>{homeData?.average_rating}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {reportee?.data !== undefined && homeData?.team_activity !== undefined && homeData?.team_activity.length > 0 &&
                                    <div className="col-md-6 col-sm-6">
                                        <div className="card">
                                            <h5 className="card-header ch-bg d-flex">Today's Meeting
                                                <div className="dropdown dropdown-data show">
                                        <span className="" href="#" role="button" id="dropdownMenuLink"
                                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="bi bi-chevron-down"></i>
                                        </span>
                                                    <div className="dropdown-menu show-dpd"
                                                         aria-labelledby="dropdownMenuLink">
                                                        {reportee?.data && reportee?.data.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <a className="dropdown-item" href="#"
                                                                       onClick={(e) => handleLastFewsDaysActivity(e, val?.id)}>{val?.name}</a>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </h5>

                                            <div className="card-body">
                                                <div className="table-wrapper-scroll-y my-custom-scrollbar">
                                                    {homeData?.team_activity.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="card-body t-table mb-2"
                                                                     style={{boxShadow: val?.status === 1 ? "rgb(235 22 22 / 80%) 0px 2px 5px" : "rgb(110 244 59 / 80%) 0px 2px 5px"}}>
                                                                    {val?.client_name !== null ?
                                                                        <>
                                                                            <div
                                                                                className="col-md-12">{val?.activity_name + " activity of  " + val?.client_name}
                                                                                <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                            </div>
                                                                        </> : val?.building_name !== null ?
                                                                        <>
                                                                            <div
                                                                                className="col-md-12">{val?.activity_name + " activity of  " + val?.building_name}
                                                                                <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                            </div>
                                                                        </> :
                                                                            <div
                                                                                className="col-md-12">{val?.activity_name + " activity of  " + val?.lead_name}
                                                                                <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                            </div>
                                                                    }
                                                                    <div className="">
                                                                        {val?.lead_id !== null ?
                                                                            parseInt(val?.assign_to) === parseInt(userId) ?
                                                                                parseInt(val?.status) === 2 ?
                                                                                    <a href={`view-activity/${val?.id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                    : (parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6) ?
                                                                                    <a href={`dealer-lead-activity-complete/${val?.lead_id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                    :
                                                                                        <a href={`v2-activity-list/${val?.opportunity_id}/${val?.account_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                :
                                                                                <a href={`view-activity/${val?.id}`}>
                                                                                    <i className="bi bi-eye dis-eye"></i>
                                                                                </a>
                                                                            :
                                                                            parseInt(val?.assign_to) === parseInt(userId) ?
                                                                                parseInt(val?.status) === 2 ?
                                                                                    <a href={`view-activity/${val?.id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                    :
                                                                                    val?.dealer_id !== null ?
                                                                                        <a href={`complete-dealer-activity/${val?.dealer_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                        : (val?.module_type === "Fasttag Toll") ?
                                                                                            <a href={`fast-tag-toll-activity-complete/${val?.id}/${val?.account_id}`}>
                                                                                                <i className="bi bi-eye dis-eye"></i>
                                                                                            </a>
                                                                                            :
                                                                                    <a href={`v2-activity-list/${val?.opportunity_id}/${val?.account_id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                :
                                                                                <a href={`view-activity/${val?.id}`}>
                                                                                    <i className="bi bi-eye dis-eye"></i>
                                                                                </a>
                                                                        }
                                                                        {/*<a href={`view-activity/${val?.id}`}><i className="bi bi-eye dis-eye"></i></a>*/}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="">
                                    {homeData?.todays_tasks !== undefined && homeData?.todays_tasks.length > 0 &&
                                        <div className="col-md-6 col-sm-6">
                                            <div className="card">
                                                <h5 className="card-header ch-bg">Next 5 Days Task</h5>
                                                <div className="card-body">
                                                    <div className="table-wrapper-scroll-y my-custom-scrollbar">
                                                        {homeData?.todays_tasks.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div className="card-body t-table mb-2">
                                                                        {val?.name !== null ?
                                                                            <div
                                                                                className="col-md-12">{val?.name + " (" + val?.user_name + " )"}
                                                                                <br/>{Moment(val?.created_at).format('DD-MMMM-YYYY')}
                                                                            </div>:
                                                                                <div
                                                                                className="col-md-12">{"Follow Up (" + val?.user_name + " )"}
                                                                                <br/>{Moment(val?.created_at).format('DD-MMMM-YYYY')}
                                                                                </div>
                                                                        }

                                                                        <div className="">
                                                                            <a href={`edit-task/${val?.id}`}><i
                                                                                className="bi bi-eye dis-eye"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {homeData?.prev_five_days_activity !== undefined && homeData?.prev_five_days_activity.length > 0 &&
                                        <div className="col-md-6 col-sm-6">
                                            <div className="card">
                                                <h5 className="card-header ch-bg">Previous 5 Days Activity</h5>
                                                <div className="card-body">
                                                    <div className="table-wrapper-scroll-y my-custom-scrollbar">
                                                        {homeData?.prev_five_days_activity.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div className="card-body t-table mb-2"
                                                                    style={{boxShadow:"rgb(235 22 22 / 80%) 0px 2px 5px"}}>
                                                                        {val?.client_name !== null ?
                                                                            <>
                                                                                <div
                                                                                    className="col-md-12">{val?.activity_name + " activity of  " + val?.client_name}
                                                                                    <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                    <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                                </div>
                                                                            </> :
                                                                            <>
                                                                                <div
                                                                                    className="col-md-12">{val?.activity_name + " activity of  " + val?.building_name}
                                                                                    <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                    <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        <div className="">
                                                                            {val?.lead_id !== null ?
                                                                                parseInt(val?.assign_to) === parseInt(userId) ?
                                                                                    (parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6) ?
                                                                                        <a href={`dealer-lead-activity-complete/${val?.lead_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                        :
                                                                                        <a href={`add-next-activity/${val?.account_id}/${val?.opportunity_id}/${val?.id}/${val?.activity_type_id}/${val?.lead_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                    :
                                                                                    <a href={`view-activity/${val?.id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                :
                                                                                parseInt(val?.assign_to) === parseInt(userId) ?
                                                                                    val?.dealer_id !== null ?
                                                                                        <a href={`complete-dealer-activity/${val?.dealer_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                        : (val?.module_type === "Fasttag Toll") ?
                                                                                            <a href={`fast-tag-toll-activity-complete/${val?.id}/${val?.account_id}`}>
                                                                                                <i className="bi bi-eye dis-eye"></i>
                                                                                            </a>
                                                                                            :
                                                                                    <a href={`add-next-activity/${val?.account_id}/${val?.opportunity_id}/${val?.id}/${val?.activity_type_id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                    :
                                                                                    <a href={`view-activity/${val?.id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                            }
                                                                            {/*<a href={`view-activity/${val?.id}`}><i className="bi bi-eye dis-eye"></i></a>*/}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {homeData?.next_five_days_activity !== undefined && homeData?.next_five_days_activity.length > 0 &&
                                        <div className="col-md-6 col-sm-6">
                                            <div className="card">
                                                <h5 className="card-header ch-bg">Next 5 Days Activity</h5>
                                                <div className="card-body">
                                                    <div className="table-wrapper-scroll-y my-custom-scrollbar">
                                                        {homeData?.next_five_days_activity.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <div className="card-body t-table mb-2">
                                                                        {val?.client_name !== null ?
                                                                            <>
                                                                                <div
                                                                                    className="col-md-12">{val?.activity_name + " activity of  " + val?.client_name}
                                                                                    <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                    <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                                </div>
                                                                            </> :
                                                                            <>
                                                                                <div
                                                                                    className="col-md-12">{val?.activity_name + " activity of  " + val?.building_name}
                                                                                    <br/>{"(" + val?.assigned_user_name + " )"}
                                                                                    <br/>{Moment(val?.activity_date).format('DD-MMMM-YYYY')}
                                                                                </div>
                                                                            </>
                                                                        }
                                                                        <div className="">
                                                                            {val?.lead_id !== null ?
                                                                                parseInt(val?.assign_to) === parseInt(userId) ?
                                                                                    (parseInt(roleId) === 41 || parseInt(roleId) === 42 || parseInt(roleId) === 6) ?
                                                                                        <a href={`dealer-lead-activity-complete/${val?.lead_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                        :
                                                                                        <a href={`add-next-activity/${val?.account_id}/${val?.opportunity_id}/${val?.id}/${val?.activity_type_id}/${val?.lead_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                    :
                                                                                    <a href={`view-activity/${val?.id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                :
                                                                                parseInt(val?.assign_to) === parseInt(userId) ?
                                                                                    val?.dealer_id !== null ?
                                                                                        <a href={`complete-dealer-activity/${val?.dealer_id}`}>
                                                                                            <i className="bi bi-eye dis-eye"></i>
                                                                                        </a>
                                                                                        : (val?.module_type === "Fasttag Toll") ?
                                                                                            <a href={`fast-tag-toll-activity-complete/${val?.id}/${val?.account_id}`}>
                                                                                                <i className="bi bi-eye dis-eye"></i>
                                                                                            </a>
                                                                                            :
                                                                                    <a href={`add-next-activity/${val?.account_id}/${val?.opportunity_id}/${val?.id}/${val?.activity_type_id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                                    :
                                                                                    <a href={`view-activity/${val?.id}`}>
                                                                                        <i className="bi bi-eye dis-eye"></i>
                                                                                    </a>
                                                                            }
                                                                            {/*<a href={`view-activity/${val?.id}`}><i className="bi bi-eye dis-eye"></i></a>*/}
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="col-md-6 col-sm-6">
                                        <div className="card">
                                            <h5 className="card-header ch-bg d-flex">
                                                Last 10 Days Inactive Accounts
                                                <div className="dropdown dropdown-data show">
                                        <span className="" href="#" role="button" id="dropdownMenuLink"
                                              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i className="bi bi-chevron-down"></i>
                                        </span>
                                                    <div className="dropdown-menu show-dpd"
                                                         aria-labelledby="dropdownMenuLink">
                                                        {reportee?.data !== undefined && reportee?.data.map((val, i) => {
                                                            return (
                                                                <>
                                                                    <a className="dropdown-item" href="#"
                                                                       onClick={(e) => handleLastFewsDaysActivity(e, val?.id)}>{val?.name}</a>
                                                                </>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </h5>
                                            <div className="card-body">
                                                <div className="table-wrapper-scroll-y my-custom-scrollbar">
                                                    {lastTenDaysInactiveAccountContent !== undefined && lastTenDaysInactiveAccountContent.length > 0 ? lastTenDaysInactiveAccountContent.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="card-body t-table mb-3"
                                                                     style={{boxShadow: "0 2px 5px " + val?.color}}>
                                                                    <div className="col-md-12">
                                                                        {val?.client_name !== "" && val?.client_name !== null ?
                                                                            val?.client_name + "( " + val?.assigned_user + " )" :
                                                                            val?.building_name + "( " + val?.assigned_user + " )"
                                                                        }
                                                                        <br/>{Moment(val?.updated_at).format('DD-MMMM-YYYY')}
                                                                        <p style={{color: val?.color}}>{val?.stage_name}</p>
                                                                    </div>
                                                                    <div className="">
                                                                        {val?.lsq_lead_id !== null ?
                                                                            <a href={`view-account/${val?.id}/${val?.lsq_lead_id}`}><i
                                                                                className="bi bi-eye dis-eye"></i></a>
                                                                            :
                                                                            <a href={`view-account/${val?.id}`}><i
                                                                                className="bi bi-eye dis-eye"></i></a>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    }) : <><p className="last-ten-day-activity">No Account Found</p></>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row">

                                    {/*END*/}
                                    {/*<div className="col-md-6 col-sm-6">*/}
                                    {/*    <div className="card shadow mb-4">*/}
                                    {/*    <div className="card-header ch-bg">*/}
                                    {/*        <h6 className="m-0 font-weight-bold">Accounts</h6>*/}
                                    {/*    </div>*/}
                                    {/*        <Chart*/}
                                    {/*            chartType="PieChart"*/}
                                    {/*            data={pieChartData}*/}
                                    {/*            options={options}*/}
                                    {/*            width={"100%"}*/}
                                    {/*            height={"400px"}*/}
                                    {/*        />*/}
                                    {/*    </div>*/}
                                    {/*</div>*/}

                                    {/*<div className="col-md-6 col-sm-6">*/}
                                    {/*    <div className="card shadow mb-4">*/}
                                    {/*    <Chart */}
                                    {/*       chartType="ColumnChart"*/}
                                    {/*       width="100%"*/}
                                    {/*       height="400px"*/}
                                    {/*       data={barChartData} />*/}
                                    {/*    </div>*/}
                                    {/*</div> */}

                                    {/* <div className="col-md-12">
                                    <div className="card shadow mb-4">
                                    <Chart
                                        chartType="Bar"
                                        width="100%"
                                        height="400px"
                                        data={dataMonth}
                                        options={optionsMonth}
                                    />
                                    </div>
                                </div>     */}

                                </div>


                            </div>
                        </div>

                        {/*END BODY*/}
                    </div>

                </div>
                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    filterContent={filterDetails}
                    handleFilter={handleFilter}
                    handleSubmitFilter={handleSubmitFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default Home